import React from 'react';

import {
    BasicField,
    BasicFieldProps,
} from 'reactApp/components/Forms/_BasicField';

import { InputFile, InputFileProps } from './InputFile/InputFile';

type Props = InputFileProps &
    Omit<BasicFieldProps, 'control'> & {
        label?: string;
    };
export class FieldFile extends React.Component<Props> {
    _fieldRef;

    render() {
        const { name, label, ...otherInputProps } = this.props;

        return (
            <BasicField
                {...{
                    label,
                    name,
                    control: InputFile,
                    innerRef: (fieldNode) => {
                        this._fieldRef = fieldNode;
                    },
                    ...otherInputProps,
                }}
            />
        );
    }
}
